import axios from 'axios'

export default {
  list(params) {
    return axios.get('/instance_users', { params }).then(response => {
      return { success: true, data: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  }
}
